import state from './moduleStockLogState.js'
import mutations from './moduleStockLogMutations.js'
import actions from './moduleStockLogActions.js'
import getters from './moduleStockLogGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

